import React from 'react';
import { Poll as PollIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { ModalPopup } from '../Elements/Modal';

import { OPEN } from '../../constants/Surveys';

export const OpenSurveyButton = ({ modalTitle, isOpen, onOpen }) => {
  if (isOpen) {
    return null;
  }

  return (
    <ModalPopup
      buttonContent={
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 1, mr: 1, color: 'black', borderColor: 'black' }}
        >
          <PollIcon sx={{ mr: 0 }} /> {OPEN}
        </Button>
      }
      title={modalTitle}
      modalButtonId={'open-survey-button'}
      handleOpen={onOpen}
      handleClose={() => {}}
      open={false}
    />
  );
};
